import { useEffect } from 'react';
import { useGame } from '../state/GameContext';

export function useTimer() {
  const { state, dispatch } = useGame();

  // Timer countdown for guessing phase (30 seconds per photo)
  useEffect(() => {
    if (state.currentPhoto && !state.photoResults && state.timeRemaining > 0) {
      const timer = setInterval(() => {
        dispatch({ type: 'SET_FIELD', field: 'timeRemaining', value: state.timeRemaining - 1 });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [state.currentPhoto, state.photoResults, state.timeRemaining, dispatch]);

  // Results countdown (5 seconds before next photo)
  useEffect(() => {
    if (state.photoResults && state.resultsCountdown > 0) {
      const timer = setInterval(() => {
        dispatch({ type: 'SET_FIELD', field: 'resultsCountdown', value: state.resultsCountdown - 1 });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [state.photoResults, state.resultsCountdown, dispatch]);
}
